import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { disableKosten } from '../../helpers/showKosten';
import { fn0nZ, fn1nZ, fn2nZ } from '../../core/formatter/formatNumber';
import { getRoutingEnergiedaten } from '../../helpers/getRoutingEnergiedaten';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungEnergiekennzahlenKostenbezogenProps extends React.ClassAttributes<any> {
    data: any;
    standortTid: number;
    standortName: string;
    onRoutingChange: (routing: any) => void;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungEnergiekennzahlenKostenbezogenState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
}

export class DatenauswertungEnergiekennzahlenKostenbezogen extends
    React.Component<DatenauswertungEnergiekennzahlenKostenbezogenProps, DatenauswertungEnergiekennzahlenKostenbezogenState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined
        };
    }

    getValues(): any {
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const kennzahlen = this.props.standortTid
            ? this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            : this.props.data[IDs.KENNZIFFERN_BERECHNET];

        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            const strom_kosten = kennzahlen[jahr] && kennzahlen[jahr].strom_kosten_gesamt ? kennzahlen[jahr].strom_kosten_gesamt : 0;
            const waerme_kosten = kennzahlen[jahr] && kennzahlen[jahr].kosten_waerme ? kennzahlen[jahr].kosten_waerme : 0;
            const kraftstoffe_kosten = kennzahlen[jahr] && kennzahlen[jahr].kraftstoffe_kosten ? kennzahlen[jahr].kraftstoffe_kosten : 0;
            const kosten_gesamt = strom_kosten + waerme_kosten + kraftstoffe_kosten;

            const anteil_strom = (100 / kosten_gesamt) * strom_kosten;
            const anteil_waerme = (100 / kosten_gesamt) * waerme_kosten;
            const anteil_kraftstoffe = (100 / kosten_gesamt) * kraftstoffe_kosten;

            const mitarbeiter = kennzahlen[jahr] && kennzahlen[jahr].mitarbeiter ? kennzahlen[jahr].mitarbeiter : 0;

            const kosten_mitarbeiter = mitarbeiter > 0 ? kosten_gesamt / mitarbeiter : 0;
            const umsatz = kennzahlen[jahr] && kennzahlen[jahr].umsatz ? kennzahlen[jahr].umsatz : 0;
            const umsatz_anteil = umsatz > 0 ? ((100 / umsatz) * kosten_gesamt) : 0;

            const row = [
                jahr,
                fn2nZ(strom_kosten), fn2nZ(waerme_kosten), fn2nZ(kraftstoffe_kosten), fn2nZ(kosten_gesamt),
                fn2nZ(anteil_strom), fn2nZ(anteil_waerme), fn2nZ(anteil_kraftstoffe),
                mitarbeiter && mitarbeiter > 0 ? fn1nZ(mitarbeiter) : ' ', fn0nZ(kosten_mitarbeiter), fn0nZ(umsatz), fn2nZ(umsatz_anteil)
            ];
            const d1 = { jahr, strom: strom_kosten || null, waerme: waerme_kosten || null, kraftstoff: kraftstoffe_kosten || null };
            const d2 = { jahr, strom: anteil_strom || 0, waerme: anteil_waerme || 0, kraftstoff: anteil_kraftstoffe || 0 };

            if (rowHasValues(row)) {
                rows.push(row);
                if (strom_kosten || waerme_kosten || kraftstoffe_kosten) {
                    diag1.push(d1);
                }
                if (anteil_strom || anteil_waerme || anteil_kraftstoffe) {
                    diag2.push(d2);
                }
            }
        }
        return { rows, diag1, diag2 };
    }

    render(): JSX.Element {
        // STROM: #6692c3
        // WÄRME: #F79646
        // KRAFTSTOFF : #0A0;
        // WASSER: #616468
        const numCols = 12;
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben

        const color: any = SectionStyle.getSectionColors() || {};
        const lineColor = [
            color.datenauswertung || '#6692c3', color.zusatztools || '#f79646', color.dateneingabe || '#0a0',
            color.informationen_hilfe || '#616468'
        ];
        // const style: any = { sub: getStyle('sub') };
        // const totalWidth = 13 * 60; // Das war die Ausgangsbasis
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        const config: any = {
            titel0: unternehmen,
            titel1: `${i18n('Energiekennzahlen', 'sys')} (${i18n('Kostenbezogen', 'sys')})`,
            titel2: this.props.standortName,
            filename: `${i18n('Energiekennzahlen', 'sys')}_${i18n('Kostenbezogen', 'sys')}_${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: {
                data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'energiekennzahlen',
                sub: 'allg_kosten'
            },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        width: `${baseWidth}%`
                    },
                    {
                        label: i18n('Energiekosten', 'sys'),
                        width: `${baseWidth * 4}%`,
                        columns: [
                            { label: i18n('Strom', 'sys'), label2: '€', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Wärme', 'sys'), label2: '€', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Kraftstoff', 'sys'), label2: '€', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Gesamt', 'sys'), label2: '€', customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    },
                    {
                        label: i18n('Anteil an Gesamtkosten', 'sys'),
                        width: `${baseWidth * 3}%`,
                        columns: [
                            { label: i18n('Strom', 'sys'), label2: '%', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Wärme', 'sys'), label2: '%', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Kraftstoff', 'sys'), label2: '%', customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    },
                    {
                        label: i18n('Anzahl{{lb}}Mitarbeitende', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'n' }
                        ]
                    },
                    {
                        label: i18n('Energiekosten/{{lb}}Mitarbeitende:r', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: '€' }
                        ]
                    },
                    {
                        label: i18n('Jahres-{{lb}}umsatz', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: '€' }
                        ]
                    },
                    {
                        label: i18n('Energiekosten am Jahresumsatz', 'sys'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: '%' }
                        ]
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header', , , , 'row_field_dark', , , , , 'row_field_dark', , 'row_field_dark'],
            diagrams: [
                {
                    title: i18n('Energiekosten', 'sys'),
                    titlePdf: i18n('Energiekosten', 'sys'),
                    legend: [`${i18n('Strom', 'sys')} [€]`, `${i18n('Wärme', 'sys')} [€]`, `${i18n('Kraftstoff', 'sys')} [€]`],
                    unit: ['€', '€', '€'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['strom', 'waerme', 'kraftstoff'],
                    data: values.diag1,
                    ignoreZeroData: true,
                    tickPeriod: [1000, 1000],
                    singleYAxis: true,
                    lineColor,
                    containerSize: {
                        width: '90%'
                    }
                },
                {
                    type: 'StackedBarChartHorizontal', // Balkendiagramm
                    XTicks: [0, 20, 40, 60, 80, 100], // In Prozent
                    title: i18n('Anteil an Gesamtkosten', 'sys'),
                    titlePdf: i18n('Anteil an Gesamtkosten', 'sys'),
                    legend: [`${i18n('Strom', 'sys')} [%]`, `${i18n('Wärme', 'sys')} [%]`, `${i18n('Kraftstoff', 'sys')} [%]`],
                    unit: ['%', '%', '%'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['strom', 'waerme', 'kraftstoff'],
                    data: values.diag2.sort((a: any, b: any) => b['jahr'] - a['jahr']),
                    ignoreZeroData: true,
                    tickPeriod: [5, 5],
                    singleYAxis: true,
                    lineColor,
                    containerSize: {
                        width: '90%'
                    }
                }
            ]
        };
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label={i18n('Datenauswertung - Hinweise', 'sys')}
                helpKey='datenauswertung_energiekennzahlen_kosten'
                type='info'
                editBar
            />
        );
        const jahresauswahl: any = <DatenauswertungJahrauswahl
            jahrMin={this.state.jahrMin}
            jahrMax={this.state.jahrMax}
            jahrFirst={this.state.firstJahr}
            jahrLast={this.state.lastJahr}
            contextKey='datenauswertung'
            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
            renderClean={true}
            wrapClass={datenauswertungStyle.datenauswertungFormField}
        />;
        const arr_header_form_elements: any[] = [
            {
                elem: jahresauswahl,
                wrapClass: 'datenauswertungContentLeft',
                skipFormFieldWrapper: true
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
        ];

        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='energiekennzahlen'
                sub='allg_kosten'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const entities: string[] = [IDs.ENT_KENNZIFFERN_GENERATED];
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingEnergiedaten(this.props.data, this.props.standortTid, entities) || {})
                })}
            />
        );
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback((!!flags.hasKraftstoffe || !!flags.hasWaerme || !!flags.hasStrom) && !disableKosten(this.props.data));
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
